import axios from 'axios';

function getCakeCmsEndpoint() {
    return window.OPTIONS.properties
        ? window.OPTIONS.properties['cakeCms.endpoint.url']
        : window.OPTIONS['cakeCms']['endpoint'];
}

export const cakeCmsClient = axios.create({
    baseURL: getCakeCmsEndpoint()
});
cakeCmsClient.interceptors.response.use(response => response.data);
